module.exports = "/assets/data/4b243a56bbd0704b0527035832e2e755-NR30.data.json";